
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/cancel",
      function () {
        return require("private-next-pages/checkout/cancel.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/cancel"])
      });
    }
  